<template>
	<v-card class="mx-auto ma-0 pa-1" outlined v-if="chart">
		<v-card-title v-if="fullScreenDlg || !slim">
			<template v-if="chart.report">
				{{ chart.report.name }}
			</template>
			<v-spacer></v-spacer>
			<v-btn icon @click="fullScreen">
				<v-icon>mdi-fullscreen</v-icon>
			</v-btn>
			<v-btn icon @click="load">
				<v-icon>mdi-reload</v-icon>
			</v-btn>
			<v-btn icon @click="edit">
				<v-icon>mdi-pencil</v-icon>
			</v-btn>
			<v-btn icon @click="sql">
				<v-icon>mdi-database-search</v-icon>
			</v-btn>
			<v-menu bottom left>
				<template v-slot:activator="{ on, attrs }">
					<v-btn icon v-bind="attrs" v-on="on">
						<v-icon>mdi-dots-vertical</v-icon>
					</v-btn>
				</template>

				<v-list>
					<v-list-item v-for="(item, i) in themes" :key="i" @click="theme = item">
						<v-list-item-title>{{ item }}</v-list-item-title>
					</v-list-item>
				</v-list>
			</v-menu>
		</v-card-title>
		<v-card-subtitle class="text-truncate">
			<template v-if="slim && chart.report">
				{{ chart.report.name }}
			</template>
			{{ chart.name }}
			<v-btn small icon @click="fullScreen">
				<v-icon>mdi-fullscreen</v-icon>
			</v-btn>
			<v-btn small icon @click="load">
				<v-icon>mdi-reload</v-icon>
			</v-btn>
		</v-card-subtitle>
		<v-card-text style="max-height: 100%; height: 100%">
			<template v-if="chart && data">
				<component :is="layout" :chart="chart" :chartData="data" :theme="theme" :height="height"></component>
			</template>
		</v-card-text>
		<v-dialog v-model="fullScreenDlg" fullscreen>
			<v-card>
				<v-card-title class="d-flex justify-space-between">
					<template v-if="chart.report">
						{{ chart.report.name }}
					</template>
					- {{ chart.name }}
					<v-spacer />
					<v-icon @click="fullScreenDlg = false">$close</v-icon>
					<v-menu bottom left>
						<template v-slot:activator="{ on, attrs }">
							<v-btn icon v-bind="attrs" v-on="on">
								<v-icon>mdi-dots-vertical</v-icon>
							</v-btn>
						</template>
						<v-list>
							<v-list-item v-for="(item, i) in themes" :key="i" @click="theme = item">
								<v-list-item-title>{{ item }}</v-list-item-title>
							</v-list-item>
						</v-list>
					</v-menu>
				</v-card-title>
				<component :is="layout" :chart="chart" :chartData="data" :theme="theme"></component>
			</v-card>
		</v-dialog>
	</v-card>
</template>

<script>
import { use, registerMap, registerTheme, connect, disconnect } from 'echarts/core'
import { kebabCase, upperFirst, clone } from 'lodash-es'

// import Vue from 'vue'

const themes = [
	'wonderland',
	'dark',
	'vintage',
	'macarons',
	'essos',
	'halloween',
	'infographic',
	'shine',
	'roma',
	'walden',
	'westeros'
]
themes.forEach((e) => {
	import(`./theme/${e}.json`).then((r) => {
		// console.log('theme', e, r)
		registerTheme(e, r.default)
	})
})

export default {
	props: {
		id: { type: [String, Number] },
		height: { type: Number, default: 200 },
		slim: { type: Boolean, default: false },
		params: { type: Object, default: () => null }
	},
	data() {
		return {
			chart: {},
			data: null,
			fullScreenDlg: false,
			theme: 'wonderland',
			themes: themes
		}
	},
	computed: {
		layout() {
			if (!this.chart || !this.chart.type) {
				return null
			}
			let template = upperFirst(this.chart.type)
			let id = kebabCase(template) + '-chart'
			return Vue.component(id, () => {
				return import(`./chart/${template}Chart.vue`)
			})
		},
		style() {
			return {
				height: this.height + 'px'
			}
		}
	},
	mounted() {
		this.load()
	},
	methods: {
		load() {
			this.$api.report.getChartById(this.id, (r) => {
				this.chart = r
				this.loadData()
			})
		},
		loadData() {
			//1. 处理chart的默认参数
			//2. 获取组件标签传入的参数（如Daily.vue中的date）
			//3. 从url中获取参数（如Report.vue中的query）
			//以上3种参数权重递增
			// console.log(this.chart)
			// let defaultParams = this.chart.params
			//     ? clone(this.chart.params)
			//     : {}
			let params = this.params ? clone(this.params) : {}
			if (this.$route.query) {
				params = Object.assign(params, this.$route.query)
			}

			this.$loading.show()
			this.$api.report.getChartData(
				`${this.id}/data`,
				params,
				(r) => {
					this.data = r
					this.$loading.hide()
				},
				(e) => {
					alert(e.message)
					this.$loading.hide()
				}
			)
		},
		fullScreen() {
			this.fullScreenDlg = true
		},
		edit() {
			this.goTo(`/report/chartupdate/${this.id}`)
		},
		sql() {
			this.$api.report.getChartData(`${this.id}/sql`, this.$route.query, (sql) => {
				this.$clipboard.copy(sql, (r) => {
					alert('SQL已复制到剪贴板')
				})
			})
		}
	},
	components: {}
}
</script>
<style scoped></style>
